/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAccessLimitResponse
 */
export interface UserAccessLimitResponse {
    /**
     * 
     * @type {string}
     * @memberof UserAccessLimitResponse
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof UserAccessLimitResponse
     */
    limit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserAccessLimitResponse
     */
    used: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessLimitResponse
     */
    remaining?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessLimitResponse
     */
    allowed: boolean;
}

/**
 * Check if a given object implements the UserAccessLimitResponse interface.
 */
export function instanceOfUserAccessLimitResponse(value: object): value is UserAccessLimitResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    if (!('allowed' in value) || value['allowed'] === undefined) return false;
    return true;
}

export function UserAccessLimitResponseFromJSON(json: any): UserAccessLimitResponse {
    return UserAccessLimitResponseFromJSONTyped(json, false);
}

export function UserAccessLimitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessLimitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'used': json['used'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
        'allowed': json['allowed'],
    };
}

export function UserAccessLimitResponseToJSON(json: any): UserAccessLimitResponse {
    return UserAccessLimitResponseToJSONTyped(json, false);
}

export function UserAccessLimitResponseToJSONTyped(value?: UserAccessLimitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'limit': value['limit'],
        'used': value['used'],
        'remaining': value['remaining'],
        'allowed': value['allowed'],
    };
}

